import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, getArticlesByCategory, getCategoryBySlug } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'yule-bagua');
  const category = getCategoryBySlug(activeSlug);
  const articles = getArticlesByCategory(activeSlug);

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [activeSlug]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <p className="text-foreground-500">分类不存在</p>
      </div>
    );
  }

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `${category.name} - ${siteInfo.name}`,
        url: `https://51chigua.com/category/${activeSlug}`,
        description: category.description,
        isPartOf: {
          '@type': 'WebSite',
          name: siteInfo.name,
          url: 'https://51chigua.com',
        },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51chigua.com' },
          { '@type': 'ListItem', position: 2, name: category.name },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="px-4 md:px-6 py-8">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]} />

              <div className="mt-6 mb-8">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                    <i className={`${category.icon} text-background-50 text-lg`}></i>
                  </span>
                  <h1 className="font-heading text-2xl md:text-3xl text-foreground-900">{category.name}</h1>
                </div>
                <p className="text-sm text-foreground-500 ml-13">{category.description}</p>
              </div>

              {/* Category Tabs */}
              <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    onClick={() => setActiveSlug(cat.slug)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      activeSlug === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {articles.length === 0 ? (
                <div className="text-center py-20">
                  <p className="text-foreground-400">该分类暂无文章</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {articles.map((article) => (
                    <ArticleCard key={article.id} article={article} variant="horizontal" />
                  ))}
                </div>
              )}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}